import { createApp } from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import setupInterceptors from './utils/api-interceptor'
import { VueReCaptcha } from 'vue-recaptcha-v3'

setupInterceptors()

createApp(App)
    .use(router)
    .use(VueGtag, { config: { id: 'G-PTK7BMQP8R' } })
    .use(VueReCaptcha, {
        siteKey: process.env.VUE_APP_RECAPTCHA_API_KEY,
        loaderOptions: {
            autoHideBadge: true,
        }
    })
    .mount('#app')
